import React from 'react';
import { translation } from '../../../_helpers/Translate';
import VisibilityIcon from '@material-ui/icons/Visibility';

const styles = { textAlign: 'center' };

export const MyReportsHistoryColumns = ({ lang, onViewReportClick }) => [
  {
    Header: 'ID',
    accessor: 'id',
    width: 50,
    style: styles
  },
  {
    Header: translation('myReportsHistory_childFullnameColumn'),
    id: 'childFullName',
    accessor: 'childFirstName',
    Cell: ({ original }) =>
      `${original.childFirstName || ''} ${original.childLastName || ''}`,
    style: styles
  },
  {
    Header: translation('myReportsHistory_childIinColumn'),
    accessor: 'childIin',
    style: styles
  },
  {
    Header: translation('myReports_ddo'),
    id: 'serviceProviderName',
    accessor: 'serviceProviderNameRu',
    Cell: ({ original }) =>
      lang === 'kk' ? original.serviceProviderNameKk : original.serviceProviderNameRu,
    style: styles
  },
  // {
  //   Header: translation('myReportsHistory_childReportMonthColumn'),
  //   accessor: 'decisionMonth',
  //   style: styles
  // },
  {
    Header: translation('myReports_status'),
    id: 'status',
    accessor: 'isConsentProvided',
    Cell: ({ value }) =>
      value ? translation('myReports_signed') : translation('myReports_rejected'),
    style: styles
  },
  {
    Header: translation('myReports_date'),
    accessor: 'consentDate',
    style: styles
  },
  {
    Header: translation('myReportsHistory_viewReport'),
    id: 'viewReport',
    accessor: 'id',
    style: styles,
    width: 100,
    Cell: ({ original }) => (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          cursor: 'pointer',
          color: '#1976d2'
        }}
        onClick={() => onViewReportClick(original)}
      >
        <VisibilityIcon />
      </div>
    )
  }
];
